import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationPreReleaseClientPut = {
    path: "/pre-release-client",
    method: ERouteHttpVerb.PUT
};
export { routeLocationPreReleaseClientPut };
